import React from 'react';

export function hasPendingAssets(document) {
  const panos = Array.isArray(document?.panos) ? document.panos : [];
  if (panos.some((pano) =>
    (pano?.assetId && pano.status !== 'ready')
    || ['queued', 'processing'].includes(String(pano?.tileState || '').toLowerCase())
    || (pano?.entryAudioAssetId && !pano.entryAudioUrl)
  )) {
    return true;
  }

  return Object.values(document?.stationsByPano || {}).some((stations) =>
    Array.isArray(stations) && stations.some((station) => station?.audioAssetId && !station.audioUrl)
  );
}

export function useAssetStatusPolling({ projectId, enabled, intervalMs, onPoll }) {
  const onPollRef = React.useRef(onPoll);
  onPollRef.current = onPoll;

  React.useEffect(() => {
    if (!projectId || !enabled) return undefined;

    let active = true;
    let running = false;
    const poll = async () => {
      if (!active || running) return;
      running = true;
      try {
        await onPollRef.current?.();
      } finally {
        running = false;
      }
    };

    void poll();
    const interval = window.setInterval(() => {
      void poll();
    }, intervalMs);
    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, [enabled, intervalMs, projectId]);
}
